import React, {useCallback, useContext, useEffect} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import BodyContentView from '../../views/bodyContentView';
import ZeroRestored from './zero-restored';
import {useMenu} from '../../../hooks/useMenu';
import CommandsContext from '../../../context/commandsContext';

function PreviousZero({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {selected, onComponent} = useMenu();
  const {onUpdateCommands} = useContext(CommandsContext);

  const onRight = useCallback(() => {
    onExit();
    onComponent(<ZeroRestored />);
  }, []);

  useEffect(() => {
    if (!leftPress) return;

    onExit();
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress) return;

    onRight();
  }, [rightPress]);

  useEffect(() => {
    onUpdateCommands({onLeft: onExit, onRight});
  }, [onExit, onRight]);

  return (
    <BodyContentView
      title="Restore Previous Zero"
      left="No"
      right="Yes"
      caption="Do you want to restore the previous zero?"
    />
  );
}

export default PreviousZero;
